import { render, staticRenderFns } from "./Cajas.vue?vue&type=template&id=0b9b53a6&scoped=true&lang=pug&"
import script from "./Cajas.vue?vue&type=script&lang=js&"
export * from "./Cajas.vue?vue&type=script&lang=js&"
import style0 from "./Cajas.vue?vue&type=style&index=0&id=0b9b53a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b53a6",
  null
  
)

export default component.exports